if (!customElements.get('html-video')) {
  class Video extends HTMLElement {

    constructor() {
      super();
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('svg');
      this.video.addEventListener('click', this.onClick.bind(this));
    }

    onClick() {
      if (this.video.paused) {
        this.video.play();
        this.playButton.classList.add('hidden');
      } else {
        this.video.pause();
        this.playButton.classList.remove('hidden');
      }
    }
  }
  customElements.define('html-video', Video);
}